
/* injects from baggage-loader */

'use strict';

import InvestmentReconfirmationModalController from './investmentreconfirmationmodal.controller';
import InvestmentReconfirmationModalTemplate from './investmentreconfirmationmodal.html';

export default class InvestmentReconfirmationModalComponent {
		constructor() {
				this.templateUrl = InvestmentReconfirmationModalTemplate;
				this.controller = InvestmentReconfirmationModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}
